import React, { useState } from 'react';
import { Pagination, Drawer, AutoComplete, Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

const EditProject = () => {
  const [projects, setProjects] = useState([
    {
      id: 1,
      name: 'Project 1',
      description: 'Description of Project 1',
      code: 'PRJ001',
      startDate: '2025-01-01',
      endDate: '2025-06-01',
    },
    {
      id: 2,
      name: 'Project 2',
      description: 'Description of Project 2',
      code: 'PRJ002',
      startDate: '2025-02-01',
      endDate: '2025-07-01',
    },
    {
      id: 3,
      name: 'Project 3',
      description: 'Description of Project 3',
      code: 'PRJ003',
      startDate: '2025-03-01',
      endDate: '2025-09-01',
    },
  ]);

  const [searchTerm, setSearchTerm] = useState('');
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [currentProject, setCurrentProject] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 2;

  const handleEdit = (projectId) => {
    const project = projects.find((p) => p.id === projectId);
    setCurrentProject(project);
    setIsEditMode(true);
    setIsDrawerOpen(true);
  };

  const closeDrawer = () => {
    setIsDrawerOpen(false);
    setCurrentProject(null);
  };

  const handleChange = (e) => {
    setCurrentProject({
      ...currentProject,
      [e.target.name]: e.target.value,
    });
  };

  const handleSave = () => {
    const updatedProjects = projects.map((project) =>
      project.id === currentProject.id ? currentProject : project
    );
    setProjects(updatedProjects);
    closeDrawer();
  };

  const filteredProjects = projects.filter((project) =>
    project.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const paginatedProjects = filteredProjects.slice(
    (currentPage - 1) * itemsPerPage,
    Math.min(currentPage * itemsPerPage, filteredProjects.length)
  );

  return (
    <div className="relative flex-1 bg-white p-10 overflow-y-auto ml-7 mr-2">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-semibold text-gray-800">Edit Projects</h1>
        <AutoComplete
          style={{ width: '300px' }}
          options={projects.map((p) => ({ value: p.name }))}
          onSelect={(value) => setSearchTerm(value)}
          onSearch={(value) => setSearchTerm(value)}
         >
          <Input prefix={<SearchOutlined />} placeholder="Search by project name" className="w-1/4 p-2 border border-gray-300 rounded-md mb-4" />
         </AutoComplete>
        
      </div>

      <div className="overflow-x-auto bg-white shadow-lg rounded-lg">
        <table className="min-w-full table-auto text-sm">
          <thead className="bg-gray-100">
            <tr>
              <th className="py-3 px-6 text-left font-medium text-gray-600">Project Name</th>
              <th className="py-3 px-6 text-left font-medium text-gray-600">Project Description</th>
              <th className="py-3 px-6 text-left font-medium text-gray-600">Code</th>
              <th className="py-3 px-6 text-left font-medium text-gray-600">Start Date</th>
              <th className="py-3 px-6 text-left font-medium text-gray-600">End Date</th>
              <th className="py-3 px-6 text-center font-medium text-gray-600">Actions</th>
            </tr>
          </thead>
          <tbody>
            {paginatedProjects.map((project) => (
              <tr key={project.id} className="hover:bg-gray-50 transition duration-300 ease-in-out">
                <td className="py-4 px-6 border-b">{project.name}</td>
                <td className="py-4 px-6 border-b">{project.description}</td>
                <td className="py-4 px-6 border-b">{project.code}</td>
                <td className="py-4 px-6 border-b">{project.startDate}</td>
                <td className="py-4 px-6 border-b">{project.endDate}</td>
                <td className="py-4 px-6 border-b text-center">
                  <button onClick={() => handleEdit(project.id)} className="text-red-600 hover:text-red-800 mr-4">
                    <i className="fas fa-edit"></i> Edit
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <Pagination
        current={currentPage}
        pageSize={itemsPerPage}
        total={filteredProjects.length}
        onChange={(page) => setCurrentPage(page)}
        className="mt-4"
      />

      {/* Drawer Component */}
      <Drawer
        title={isEditMode ? 'Edit Project' : 'View Project'}
        placement="right"
        closable={true}
        onClose={closeDrawer}
        open={isDrawerOpen}
        width={400}
      >
        {currentProject && (
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium">Project Name</label>
              <input
                type="text"
                name="name"
                value={currentProject.name}
                onChange={handleChange}
                disabled={!isEditMode}
                className="w-full p-2 border border-gray-300 rounded"
              />
            </div>
            <div>
              <label className="block text-sm font-medium">Project Description</label>
              <textarea
                name="description"
                value={currentProject.description}
                onChange={handleChange}
                disabled={!isEditMode}
                className="w-full p-2 border border-gray-300 rounded"
                rows={3}
              />
            </div>
            <div>
              <label className="block text-sm font-medium">Code</label>
              <input
                type="text"
                name="code"
                value={currentProject.code}
                onChange={handleChange}
                disabled={!isEditMode}
                className="w-full p-2 border border-gray-300 rounded"
              />
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium">Start Date</label>
                <input
                  type="date"
                  name="startDate"
                  value={currentProject.startDate}
                  onChange={handleChange}
                  disabled={!isEditMode}
                  className="w-full p-2 border border-gray-300 rounded"
                />
              </div>
              <div>
                <label className="block text-sm font-medium">End Date</label>
                <input
                  type="date"
                  name="endDate"
                  value={currentProject.endDate}
                  onChange={handleChange}
                  disabled={!isEditMode}
                  className="w-full p-2 border border-gray-300 rounded"
                />
              </div>
            </div>
          </div>
        )}

        {isEditMode && (
          <button onClick={handleSave} className="bg-blue-600 text-white px-4 py-2 rounded mt-4">
            Save
          </button>
        )}
      </Drawer>
    </div>
  );
};

export default EditProject;
